
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PRODUCTS, CATEGORY_MAP } from '../constants';

const SITE = 'https://www.sanan-wear.es';
const DEFAULT_TITLE = 'SANAN Wear - Ropa del mundo del motor';
const DEFAULT_DESCRIPTION = 'SANAN Ropa Motor: Elegancia y Estilo Inspirado en los Coches más clásicos';

// Título y descripción de cada página (lo que Google muestra en los resultados)
const PAGES: Record<string, { title: string; description: string }> = {
  '/': {
    title: 'SANAN Wear | Ropa personalizada con tu coche y diseños del motor',
    description: 'Sudaderas, camisetas, tazas y botellas con diseños de coches clásicos y de rally. Personaliza cualquier prenda con tu propio coche. Envío gratis a partir de 65€.',
  },
  '/shop': {
    title: 'Tienda | SANAN Wear',
    description: 'Sudaderas, camisetas, tazas, botellas y tote bags inspiradas en el mundo del motor. Diseños originales de coches clásicos, rally y F1.',
  },
  '/collections': {
    title: 'Colecciones | SANAN Wear',
    description: 'Descubre las colecciones MINIMAL, GRAPHIC y SANAN: ropa y accesorios con diseños originales de coches.',
  },
  '/custom': {
    title: 'Personaliza tu ropa con tu coche | SANAN Wear',
    description: 'Envíanos una foto de tu coche y lo convertimos en un diseño para tu sudadera, camiseta, taza o botella. El regalo perfecto para un amante del motor.',
  },
  '/about': {
    title: 'Sobre nosotros | SANAN Wear',
    description: 'SANAN nace en Sabadell de la pasión por el motor. Diseños 100% originales en prendas de calidad premium.',
  },
  '/contact': {
    title: 'Contacto | SANAN Wear',
    description: '¿Tienes dudas sobre un pedido o una personalización? Escríbenos por email, WhatsApp o Instagram.',
  },
  '/envios-devoluciones': {
    title: 'Envíos y devoluciones | SANAN Wear',
    description: 'Plazos de envío, gastos de envío y política de devoluciones de SANAN Wear.',
  },
};

function setMeta(selector: string, attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = content;
}

const PageMeta: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    let { title, description } = PAGES[pathname] || { title: DEFAULT_TITLE, description: DEFAULT_DESCRIPTION };

    const productId = pathname.match(/^\/product\/(.+)$/)?.[1];
    const product = productId && PRODUCTS.find(p => p.id === decodeURIComponent(productId));
    if (product) {
      title = `${product.name.trim()} | SANAN Wear`;
      description = `${product.name.trim()} por ${product.price.toFixed(2)}€. ${product.description}. ${product.details} Envío gratis a partir de 65€.`;
    }

    const category = pathname === '/shop' && new URLSearchParams(search).get('category');
    if (category && category !== 'Todo') {
      title = `${CATEGORY_MAP[category] || category} de coches | SANAN Wear`;
    }

    document.title = title;
    setMeta('meta[name="description"]', 'name', 'description', description);
    setMeta('meta[property="og:title"]', 'property', 'og:title', title);
    setMeta('meta[property="og:description"]', 'property', 'og:description', description);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = SITE + pathname;
  }, [pathname, search]);

  return null;
};

export default PageMeta;
